import { CollectionFilterOperator } from '../enums/collection-filter-operator';
import { CollectionFilterRequest } from '../requests/collection-filter.request';
import { isNil, Nillable } from '@web/utils';
import { CollectionFilterKey } from '../../collection/types/collection-filter-key';
import { BaseCollectionFilterRequestBuilder } from './base-collection-filter-request.builder';

export class DateCollectionFilterRequestBuilder<
  Filter,
> extends BaseCollectionFilterRequestBuilder<Filter> {
  public range(): this {
    return this.operator(CollectionFilterOperator.DateRange);
  }

  public rangeFor(property: CollectionFilterKey<Filter>): this {
    return this.range().property(property);
  }

  public override build(): Nillable<CollectionFilterRequest> {
    this.configureDefaultOperator();

    return super.build();
  }

  private configureDefaultOperator(): void {
    if (!isNil(this._operator)) {
      return;
    }

    this.range();
  }
}
